import { privateApi } from 'api'
import { AxiosResponse } from 'axios'
import {
  ISeoPageQueryRequest,
  ISeoPageQueryResponse,
  ICreateSeoPageRequest,
  IUpdateSeoPageRequest,
  ISeoPage,
  ISubCategoryFilter,
  IFilterValueCount
} from 'models/seoPages'

export const seoPageApi = {
  getSeoPages({
    skip,
    limit,
    name,
    url,
    type
  }: ISeoPageQueryRequest): Promise<AxiosResponse<ISeoPageQueryResponse>> {
    const params = new URLSearchParams({
      skip: skip.toString(),
      limit: limit.toString()
    })

    if (name) params.append('name', name)
    if (url) params.append('url', url)
    if (type) params.append('type', type)

    return privateApi.get<ISeoPageQueryResponse>(`admin/seo-page?${params.toString()}`)
  },

  getSeoPageById(id: string): Promise<AxiosResponse<ISeoPage>> {
    return privateApi.get<ISeoPage>(`admin/seo-page/${id}`)
  },

  createSeoPage(
    data: ICreateSeoPageRequest
  ): Promise<AxiosResponse<ISeoPage>> {
    return privateApi.post<ISeoPage>('admin/seo-page', data)
  },

  updateSeoPage(
    id: string,
    data: IUpdateSeoPageRequest
  ): Promise<AxiosResponse<ISeoPage>> {
    return privateApi.patch<ISeoPage>(`admin/seo-page/${id}`, data)
  },

  deleteSeoPage(id: string): Promise<AxiosResponse<void>> {
    return privateApi.delete<void>(`admin/seo-page/${id}`)
  },

  deleteSeoPages(ids: string[]): Promise<AxiosResponse<void>> {
    return privateApi.delete<void>('admin/seo-page', {
      data: { ids }
    })
  },

  getFilters(
    subCategoryId: string
  ): Promise<AxiosResponse<ISubCategoryFilter[]>> {
    return privateApi.get<ISubCategoryFilter[]>(`admin/filters/${subCategoryId}`)
  },

  getFilterValuesCount(
    subCategoryId: string
  ): Promise<AxiosResponse<IFilterValueCount[]>> {
    return privateApi.get<IFilterValueCount[]>(
      `admin/seo-page/filters-count?subCategory_id=${subCategoryId}`
    )
  }
}